import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";

export default function ProtectedRoutes(props: any) {
  const location = useLocation();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  // not authenticated, redirect to /login
  return authStatus === "authenticated" ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
}
